import React, { useEffect, useState } from 'react'
import useAuth from '../context/hook/useAuth'
import { Link, useNavigate } from 'react-router-dom'

//form
import {useForm} from "react-hook-form"
import * as yup from "yup"
import {yupResolver} from "@hookform/resolvers/yup"

//firebase
import { dataBase } from "../utils/FirebaseConfig"
import { signInWithEmailAndPassword } from 'firebase/auth'
import site from "../utils/SiteSettings"

//api
import axios from "../utils/axios"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'
import { Register } from '../Register/Register'

//icon
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye,faEyeSlash,faXmark } from '@fortawesome/free-solid-svg-icons';
   

export const Login = () => {

  const {setAuth,user} = useAuth()
  const navigate = useNavigate()

  const [showIcon, setShowIcon] = useState(false)

    

  // eslint-disable-next-line
  const schema = yup.object().shape({
    email:yup.string().email().required(),
    password:yup.string().min(7).max(20).required(),
  })
  
  const {register, handleSubmit, reset, formState: { errors }} = useForm({
    resolver: yupResolver(schema)
  });


  const onSubmit = async(data,e)=>{
    e.preventDefault();
    console.log("done")
    try {
        //this is used to verfiy the auth using firebase
        await signInWithEmailAndPassword(dataBase,data.email,data.password)
        .then(async()=>{ 
            await axios.post("/login", 
            {
              email:data.email,
              // password:data.password
            },
            {
              headers:{"Content-Type": "application/json"},
              withCredentials:true,
            }
        ).then(async(response)=>{
        //   console.log(response.data);
          const token = response?.data?.token
          let otp = response?.data?.otp

          window.localStorage.setItem("IsLoggedIn", true)
          setAuth({token,otp})
          setTimeout(()=>{
            navigate('/otp',{replace: true})
          },2000)

          toast.success(<div>OTP has been sent to your email.<br/> Please verify the otp</div>,{enableHtml: true,position:'top-right'})
        }).catch((err)=>{
            console.log(err)
            if(err.response.data.match("Unauthorized")){
                toast.error("Email not found. Please register and after try to login",{position:"top-right"})
            }
        })
      })  
    } catch (error) {
        console.log(error.message)
        if(error.message.match("invalid-credential")){
          toast.error("Please enter a valid email and password",{position:"top-right"})
        }
    }
  }  

  const handlSshowHide =()=>{
    setShowIcon(!showIcon)
  }
   // eslint-disable-next-line
  useEffect(()=>{if(user) return navigate(-1)},[])

  return (
    <div>
        {/* <!-- login section start --> */}
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                <div className="loging-logo">
        <Link to={'/'} className="">
            {/* Coinstirs */}
            <img  src={require("../../assets/logo.png")} className="img-fluid robot-img" alt="robot" />
            </Link>
        </div>
                </div>
            </div>
        </div>
        <section className="login-section">
           
            <div className="row m-0">
                <div className="col-lg-7 d-lg-inline-block d-none p-0">
                    <div className="log-display">
                    <img  src={require("../../assets/logo-banner.png")} className="img-fluid robot-img" alt="robot" />
                    </div>
                    {/* <div className="login-animation">
                        <img src={require("../../assets/svg/home/log3.svg").default} data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100" className="img-fluid img-base aos-animate w-600" alt=""/>
                        <img src={require("../../assets/svg/home/log1.svg").default} data-aos="zoom-in-up" data-aos-duration="1000" data-aos-delay="1000" className="img-fluid img-light aos-animate w-600" alt=""/>
                        <div className="img-face aos-animate" data-aos-delay="2500" data-aos="flip-left" data-aos-easing="ease-out-cubic"
                            data-aos-duration="1000"> <img src={require("../../assets/svg/home/log.svg").default} className="img-fluid w-450" alt=""/></div>
                    </div> */}
                </div>
                <div className="col-xxl-4 col-lg-5 ms-auto p-0">
                    <div className="login-box">
                        <div>
                            <h2>Welcome to <span>{site?.site?.siteName} !</span></h2>
                            <ul className="nav nav-tabs" id="myTab" role="tablist">
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="login-tab" data-bs-toggle="tab"
                                        data-bs-target="#login-tab-pane" type="button" role="tab"
                                        aria-controls="login-tab-pane" aria-selected="true">Login</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="signup-tab" data-bs-toggle="tab"
                                        data-bs-target="#signup-tab-pane" type="button" role="tab"
                                        aria-controls="signup-tab-pane" aria-selected="false">signup</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="myTabContent" >
                                <div className="tab-pane fade show active" id="login-tab-pane" role="tabpanel"
                                    aria-labelledby="login-tab" tabIndex="0">
                                    <form className="auth-form" onSubmit={handleSubmit(onSubmit)}>
                                        <div className="mb-3 form-group">
                                            <i className="iconsax" data-icon="mail"></i>
                                            <label htmlFor="emailid" className="form-label">Email ID</label>
                                            <input {...register("email")} type="email" placeholder="Enter your mail id" className="form-control"
                                                id="emailid"/>
                                                {errors.email && <p>Email must match</p>}
                                        </div>
                                        <div className="mb-2 form-group pos-rel">
                                            <i className="iconsax" data-icon="lock-2"></i>
                                            <label htmlFor="password" className="form-label">Password</label>
                                            <input {...register("password")} placeholder="Enter your password" type={showIcon ? "text" : "password"} className="form-control"
                                                id="password"/>
                                                {errors.password && <p style={{fontSize:'12px',color:'red'}}>Password has to be between 8-30 characters, and contains at least one uppercase letter, one lowercase letter and a number</p>}
                                                {/* <span className="eye"><i className="fa-regular fa-eye-slash"></i></span> */}
                                                <div className='log-icon'>
                                                    <FontAwesomeIcon icon={faXmark} onClick={()=>{reset({password:""})}} />
                                                    {
                                                        showIcon ? (
                                                            <FontAwesomeIcon icon={faEye}  id='show_hide' onClick={handlSshowHide}  />
                                                        ) : (
                                                            <FontAwesomeIcon icon={faEyeSlash}  id='show_hide' onClick={handlSshowHide}  />
                                                        )
                                                    }
                                                </div>
                                        </div>
                                        <div className="text-end">
                                            <Link data-cursor="pointer" to={'/forgot'}>Forget Password?</Link>
                                        </div>
                                        <button type='submit' data-cursor="pointer" className="btn-solid w-100 text-center mt-3">Log me
                                            in</button>
                                        <h4 className="text-title text-center mt-2">
                                            Don’t have an account ? 
                                            <a data-cursor="pointer" style={{cursor:"pointer"}} href onClick={()=>document.getElementById('signup-tab').click()} >
                                                Sign up
                                            </a>
                                        </h4>
                                        <div className="ovr-hidden">
                                            <div className="divider">
                                                <h3>or sign in with</h3>
                                            </div>
                                            <ul className="social-btn">
                                                <li>
                                                    <a data-cursor="pointer" href="https://www.google.com/">
                                                        <img src="https://themes.pixelstrap.net/mega_bot/assets/svg/google.svg" alt='' className="img-fluid"/>
                                                        Continue with google
                                                    </a>
                                                </li>
                                                <li>
                                                    <a data-cursor="pointer" href="https://www.apple.com/">
                                                        <img src="https://themes.pixelstrap.net/mega_bot/assets/svg/apple.svg" alt='' className="img-fluid"/>
                                                        Continue with apple
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </form>
                                </div>
                                <div className="tab-pane fade" id="signup-tab-pane" role="tabpanel" aria-labelledby="signup-tab" tabIndex="0">
                                    <Register/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        {/* <!-- login section end -->         */}
    </div>
  )
}
